import MarkdownIt from 'markdown-it';
import DOMPurify from 'dompurify';

export const md = new MarkdownIt({
  html: false,
  linkify: true,
  typographer: true,
});

export function renderMarkdown(source: string): string {
  const raw = md.render(source);
  return DOMPurify.sanitize(raw);
}
